module.exports = __webpack_public_path__ + "static/media/ws02.404d25b2.webp";